"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authenticationService = exports.removeUserManager = exports.getUserManager = void 0;
const oidc_client_1 = require("oidc-client");
let userManager;
const getUserManager = () => {
    return userManager;
};
exports.getUserManager = getUserManager;
const removeUserManager = () => {
    userManager = undefined;
};
exports.removeUserManager = removeUserManager;
const authenticationService = (configuration) => {
    if (userManager) {
        return userManager;
    }
    userManager = new oidc_client_1.UserManager(configuration);
    return userManager;
};
exports.authenticationService = authenticationService;
//# sourceMappingURL=authentication-service.js.map